import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {SessionStoreDataService} from '../../projects/products-lib/src/lib/services/session-store-data.service';

/**
 * Guard for the /product-selector route.
 * Pupil members should never see the product selector — redirect them to /11-plus-online-tests.
 */
export const productSelectorGuard: CanActivateFn = () => {
  const sessionStore = inject(SessionStoreDataService);
  const router = inject(Router);
  const decodedToken = sessionStore.getDecodedTokenUser();

  if (decodedToken?.isPupilMember) {
    return router.createUrlTree(['/11-plus-online-tests']);
  }

  return true;
};


